import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
export const LoadingModal = (props: { title: string, onClose: () => void }) =>
(<Modal isOpen={true} onClosed={props.onClose}>
  <ModalHeader>
    <span>{props.title}</span>
  </ModalHeader>
  <ModalBody>
    Please wait loading required data...
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={props.onClose}>Cancel</Button>
  </ModalFooter>
</Modal>)
